import {mergeProperties} from "../components/Utility";
import ActionDropdown from "../components/actions/ActionDropdown";
import React from "react";

export const getBankSettingFormData = (data) => {
    const initialData = {
        name: '',
        accountHolderName: '',
        accountNumber: '',
        ifscCode: '',
        branchAddress: '',
        upiId: '',
    }
    // fill data in initialData from data
    return mergeProperties(initialData, data);
};


export const getTableColumns = () => {

    let tableColumns = [
        {header: "Bank Name", field: "name"},
        {header: "Account Holder Name", field: "accountHolderName"},
        {header: "Account Name", field: "accountNumber"},
        {header: "IFSC Code", field: "ifscCode"},
        {header: "UPI Id", field: "upiId"},
    ];

    tableColumns.push({
        header: 'Action',
        disableSorting: true,
        field: 'action',
        align: "right",
        render: (row) => {
            return <ActionDropdown row={row}/>;
        },
    });
    return tableColumns;
};


export const getTableData = ({items = []}) => {
    if (!Array.isArray(items)) return [];
    return items.map(item => ({
        id: item.id,
        name: item.name,
        accountHolderName: item.accountHolderName,
        accountNumber: item.accountNumber,
        ifscCode: item.ifscCode,
        branchAddress: item.branchAddress,
        upiId: item.upiId,
    }));
}

export const getDetailData = ({item}) => {
    if (!item) return {details: {}};
    return {
        details: {
            id: item.id,
            name: item.name,
            accountHolderName: item.accountHolderName,
            accountNumber: item.accountNumber,
            ifscCode: item.ifscCode,
            branchAddress: item.branchAddress,
            upiId: item.upiId,
        },
    };
};